import z from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { ApolloCompanies } from '@/features/apollo-companies'

const searchSchema = z.object({
  page: z.number().optional().catch(1),
  pageSize: z.number().optional().catch(50),
  filter: z.string().optional().catch(''),
  linkedStatus: z
    .enum(['all', 'linked', 'unlinked'])
    .optional()
    .catch(undefined),
  enrichedStatus: z
    .enum(['all', 'enriched', 'plain'])
    .optional()
    .catch(undefined),
  lemlistStatus: z
    .enum(['all', 'enriched', 'not_found', 'pending'])
    .optional()
    .catch(undefined),
  companyId: z.string().optional(),
  industries: z.array(z.string()).optional().catch([]),
  countries: z.array(z.string()).optional().catch([]),
  fundingStages: z.array(z.string()).optional().catch([]),
  employeeCount: z.string().optional(),
  revenue: z.string().optional(),
  foundedYear: z.string().optional(),
  sortBy: z.string().optional(),
  sortOrder: z.enum(['asc', 'desc']).optional().catch(undefined),
})

export const Route = createFileRoute('/_authenticated/apollo-companies/')({
  validateSearch: searchSchema,
  component: ApolloCompanies,
})
